<script>
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';

	/**
	 * @typedef {Object} Props
	 * @property {string} [src] - The URL of the Youtube video.
	 * @property {string} [videoId] - The ID of the Youtube video.
	 * @property {string} [posterImageSrc] - The URL of the poster image for the video.
	 * @property {string} [title] - The title of the video feature section.
	 * @property {string} [body] - The body content of the video feature section (used if no slot content is provided).
	 * @property {'blue' | 'grey' | 'grey-light' | 'grey-dark' | 'white' | 'transparent'} [backgroundColor] - The background color of the component.
	 * @property {string} [class] - Additional CSS classes for the element.
	 */
	/** @type {Props} */
	let {
		src = null,
		videoId = null,
		posterImageSrc = null,
		title = null,
		body = null,
		backgroundColor = 'blue',
		class: className = null,
		children,
	} = $props();
</script>

<article
	class={[
		'mx-auto mb-4 grid w-full max-w-xl rounded-lg px-8 py-7 shadow-md',
		{
			'bg-indow-blue': backgroundColor == 'blue',
			'bg-indow-grey-light': backgroundColor == 'grey-light',
			'bg-indow-grey': backgroundColor == 'grey',
			'bg-indow-grey-dark': backgroundColor == 'grey-dark',
			'bg-indow-white': backgroundColor == 'white',
		},
		className,
	]}
>
	{#if title}
		<h2>{title}</h2>
	{/if}
	{#if children}
		{@render children()}
	{:else if body}
		<p>{body}</p>
	{/if}
	<Youtube {src} {videoId} {posterImageSrc} class="rounded-lg" />
</article>
